module.exports = __webpack_public_path__ + "static/media/After School.a06455f5.jpg";